import { FormGroup } from "@angular/forms";
import { CommonField } from "../Field/FieldBase";

export function makeFieldGroup(options: FieldGroupDefinition, { localize }) {
  let self: FieldGroupDefinition = {
    name: options.name,
    label: options.label || (options.fieldTag ? localize(options.fieldTag) : ''),
    description: options.description,
    isVisible: options.isVisible,
    isHeaderVisible: options.isHeaderVisible,
    renderingDirection: options.renderingDirection,
    fieldsPerLine: options.fieldsPerLine,
    fields: options.fields
  }

  return self;
}

// renderable field groups need to be remade every time group settings change in order reflect the state
export function makeRenderableFieldGroup(options: FieldGroupDefinition): RenderableFieldGroup {

  const fieldLines = makeFieldLines(options.fields, options.renderingDirection || 'horizontal', options.fieldsPerLine || 3)
  const isEmpty = !fieldLines.filter(fl => fl.isVisible).length;
  const isVisible = isEmpty ? () => false : options.isVisible;

    let self: RenderableFieldGroup = {
      name: options.name,
      label: options.label,
      isVisible,
      description: options.description,
      fieldLines: fieldLines,
      isHeaderVisible: options.isHeaderVisible
    };

  return self;
}

export interface RenderableFieldGroup {
  name?: string;
  label?: string;
  isVisible?: ((form: FormGroup) => boolean) | boolean;
  isHeaderVisible?: boolean;
  description?: string;
  fieldLines?: FieldLine[];
}

export interface FieldGroupDefinition {
  name?: string;
  fieldTag?: string;
  label?: string;
  isVisible?: ((form: FormGroup) => boolean) | boolean;
  isHeaderVisible?: boolean;
  description?: string;
  renderingDirection?: 'horizontal' | 'vertical';
  fieldsPerLine?: number;
  fields?: CommonField[];
}

export interface FieldLine {
  fields: FieldWithClassData[];
  widthModifier?: number;
  isVisible?: boolean;
}

interface FieldWithClassData {
  field: CommonField,
  widthModifier?: number;
}

// UTILITES
function makeFieldLines(fields: CommonField[], renderingDirection: 'horizontal' | 'vertical' = 'horizontal', fieldsPerLine: number = 1) {
  const isHorizontalRendering = renderingDirection.toLowerCase() === 'horizontal'

  const fieldLines: FieldLine[] = [];

  const manuallyHiddenFields = fields.filter(f => f.isManuallyHidden)
  const notHiddenFields = fields.filter(f => !f.isManuallyHidden)

  notHiddenFields.forEach((f, i) => {
    const lineIndex = Math.floor(i / fieldsPerLine);
    if (!fieldLines[lineIndex]) {
      fieldLines[lineIndex] = {
        fields: [],
        isVisible: true
      };
    }
    fieldLines[lineIndex].fields.push({
      field: f
    });
  });

  // calculate column widths
  if (isHorizontalRendering) {
    fieldLines.forEach(fl => ({ widthModifier: 12, ...fl }))
  } else {
    let widthModifier = Math.ceil(12 / fieldLines.length)
    let isColWidthVariable = fieldLines.length === 5;
    fieldLines.forEach((fl, i) => {
      if (isColWidthVariable && i >= 2) {
        widthModifier = 2;
      }
      fl.widthModifier = widthModifier;
    })
  }

  // calculate field widths
  if (isHorizontalRendering) {
    let isFieldWidthVariable = fieldsPerLine === 5;
    fieldLines.forEach((line) => {
      let widthModifier = Math.ceil(12 / fieldsPerLine)
      line.fields.forEach((f, i) => {
        if (isFieldWidthVariable && i >= 2) {
          widthModifier = 2;
        }
        f.widthModifier = widthModifier
      });
    });
  } else {
    fieldLines.forEach((line) => {
      line.fields.forEach((f) => {
        f.widthModifier = 12
      });
    });
  }

  if (manuallyHiddenFields) {
    fieldLines.push({ fields: manuallyHiddenFields.map(f => ({ field: f })), isVisible: false })
  }

  return fieldLines;
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-generic-form/generic-editor/models/FieldGroup/FieldGroup.ts